import React from 'react';
import {Modal} from '@mui/material';
import {ConfigLayout} from './ConfigLayout/ConfigLayout';
import './ConfigsModal.scss';
import {withRouter} from '../../../utils/helpers';

const ConfigsModal = ({
  part,
  open,
  setOpen,
  confirm,
  editConfigId,
  searchParams,
  setSearchParams,
}) => {
  const closeModal = () => {
    setSearchParams([
      ...Array.from(searchParams).filter(([key]) => key !== 'configId'),
    ]);
    setOpen(false);
    confirm(true);
  };

  return (
    <Modal open={open} onClose={closeModal} disableEnforceFocus={true}>
      <div className="config-modal">
        <ConfigLayout
          part={part}
          closeModal={closeModal}
          editConfigId={editConfigId}
        />
      </div>
    </Modal>
  );
};

export default withRouter(ConfigsModal);
